import { createRequestTypes } from 'common/websocket-redux';

export const GET_PURCHASE_HISTORY = createRequestTypes(
  'purchase-history-page/GET_PURCHASE_HISTORY',
);
